import { ProductListModel } from 'api-hooks/product/list';
import { generateId } from 'common/utils/string';
import React from 'react';

import {
  ProductFormType,
  ProductVariantFormType,
} from '../components/form-type';

export function onAddNewProductVariant(): ProductVariantFormType {
  return {
    description: '',
    id: undefined,
    customId: generateId(),
    name: '',
    sellPrice: undefined,
    stock: undefined,
    averagePrice: undefined,
  } as unknown as ProductVariantFormType;
}

export default function useGetDefaultValues(product?: ProductListModel) {
  const defaultValues = React.useMemo<ProductFormType>(() => {
    const productVariants: ProductVariantFormType[] =
      product?.productVariants?.map((pv) => {
        return {
          customId: generateId(),
          id: pv.id,
          description: pv.description || '',
          name: pv.name || '',
          sellPrice: pv.sellPrice || 0,
          stock: pv.stock || 0,
        };
      }) ?? [onAddNewProductVariant()];

    return {
      code: product?.code || '',
      description: product?.description || '',
      name: product?.name || '',
      productVariants,
      product,
    };
  }, [product]);

  return defaultValues;
}
